import { useMemo } from "react";
import { AccommodationAPIPromiseClient } from "../../../../gen/witbooking/backoffice/accommodation/v1/accommodation_api_grpc_web_pb";
import { GetAccommodationCategoryLimitsRequest } from "../../../../gen/witbooking/backoffice/accommodation/v1/accommodation_api_pb";
import { useGrpcClient, usePropertyGrpcCall } from "../../../../lib/grpc";
import { CategoryLimits } from "../../domain/entities/CategoryLimits";
import { CategoryLimitsMapper } from "../mappers/CategoryLimitsMapper";

export function useCategoryLimitsApi() {
  const grpcClient = useGrpcClient(AccommodationAPIPromiseClient);
  const getAccommodationCategoryLimits = usePropertyGrpcCall(
    grpcClient,
    grpcClient.getAccommodationCategoryLimits
  );

  return useMemo(
    () => ({
      /** `accommodationId` is empty for an accommodation being created. */
      getAccommodationCategoryLimits: async (
        accommodationId: string,
        locale: string
      ): Promise<CategoryLimits> => {
        const request = new GetAccommodationCategoryLimitsRequest();
        request.setAccommodationId(accommodationId);
        request.setLocale(locale);
        const response = await getAccommodationCategoryLimits(request);
        return CategoryLimitsMapper.toDomain(response);
      },
    }),
    [getAccommodationCategoryLimits]
  );
}
